export default __webpack_public_path__ + "static/media/needHelp.7c355e99.png";